module.exports = "/images/necklace.svg?00a861a43e2c198ef1dd64a856acb15f";